// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1969":"1c75c272","3072":"1c75c272","6375":"1c75c272","7793":"1c75c272","9317":"1c75c272","9781":"1c75c272"}[chunkId] + ".chunk.css";
};